<template>
  <div class="max-w-7xl mx-auto">
    <RouterView />
  </div>
</template>


<script setup>
/**
 * @component RouterBypass
 * @description WHAT: Concise summary of what this component does. WHY: Business or UX reason. WHEN: When it runs or reacts. HOW: Key techniques (state, props, emits).
 */
</script>
